define('areas/autologout/viewmodels/autologout',["require", "exports", "plugins/dialog", "models/account", "models/portal"], function (require, exports, dialog, Account, Portal) {
    "use strict";
    var AutoLogoutViewModel = (function () {
        function AutoLogoutViewModel() {
            this.remainingSeconds = 60;
            ko.track(this);
            var self = this;
            var shell = Portal.Context.shell;
            this.timer = setInterval(function () {
                self.remainingSeconds--;
                if (self.remainingSeconds == 0) {
                    self.clearInterval();
                    shell.triggerActivityTimeOut();
                }
            }, 1000);
            var setCss = setInterval(function () {
                var modalHost = document.getElementsByClassName('modalHost');
                modalHost[0].setAttribute("style", "display: block !important; z-index: 1052; opacity: 1");
                clearInterval(setCss);
            }, 1000);
        }
        AutoLogoutViewModel.prototype.abortLogout = function () {
            dialog.close(this);
            clearInterval(this.timer);
            Account.Session.guardUserActivity();
        };
        AutoLogoutViewModel.prototype.clearInterval = function () {
            clearInterval(this.timer);
        };
        return AutoLogoutViewModel;
    }());
    return AutoLogoutViewModel;
});

